import React, { useEffect, useState } from 'react';
import styles from '../../../../styles/modules/RegistrationSetup.module.css';
import { getFieldsByType } from '../helper.jsx';
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI.js';
import { useSelector } from 'react-redux';
import Loader from '../../../../component/Loader.jsx';
import ParticipantFeeCard from './ParticipantFeeCard.jsx';
import { Accordion, AccordionDetails, AccordionSummary, Radio, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../../redux/reducer/rootReducer.js';
import { Privileges } from '../../../../util/PrivilegeConstants.js';
import { getLogoByPaymentMethodName } from '../../../../util/PaymentUtil.js';

const FormOverview = ({ formTemplateId, formtemplateStatus, setIsUpdate, privileges }) => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const userInfo = useSelector((store) => store.user.userInfo);
    const [formFieldsWithSection, setFormFieldsWithSection] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [participantFeeList, setParticipantFeeList] = useState([]);
    const [waiverList, setWaiverList] = useState([]);
    const [paymentMethodDetails, setPaymentMethodDetails] = useState({ offline_payment: [], online_payment: [] });
    const dispatch = useDispatch();
    const [paymentMethodType, setPaymentMethodType] = useState([])


    const handlePaymentMethodType = (type, val) => {
        if (val) {
            if (!paymentMethodType.includes(type)) {
                setPaymentMethodType(prev => [...prev, type])
            }
        } else {
            setPaymentMethodType(paymentMethodType.filter(item => item !== type));
        }

    };

    const getAllFormFieldsWithSection = async () => {
        try {
            setIsLoading(true)
            const response = await FormTemplateAPI.getAllFormFieldsWithSection(selectedClub.clubId, formTemplateId);
            setFormFieldsWithSection(response.Data);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getAllParticipantFee = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllSelectedParticipantFee(formTemplateId);
            setParticipantFeeList(response.Data)
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const findAllWaiver = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllAttachedWaiver(formTemplateId);
            setWaiverList(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const getAllAttachedPaymentMethod = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllAttachedPaymentMethod(formTemplateId);
            setPaymentMethodDetails({
                online_payment: response.Data.onlinePaymentMethods,
                offline_payment: response.Data.offlinePaymentMethods
            });
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleFormReview = async (action) => {

        try {
            setIsLoading(true)
            const reqData = {
                formTemplateId: formTemplateId,
                actionBy: userInfo.userId,
                action: action
            }
            await FormTemplateAPI.postFormTemplateApproveOrReject(reqData);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: `This form template is ${action === 'Approve' ? 'Approved' : 'Rejected'}` }))
            setIsUpdate(true);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        getAllFormFieldsWithSection();
        getAllParticipantFee();
        findAllWaiver();
        getAllAttachedPaymentMethod();
    }, []);
    const radioBtnStyle = {
        '&.Mui-checked': {
            color: 'var(--hoverColorBold)', // checked color
        },
        '&.Mui-checked ~ .MuiFormControlLabel-label': {
            color: 'var(--hoverColorBold)',
        },
    };


    return (
        <div className={styles['form_overview_container']}>
            {isLoading && <Loader />}
            <div className={styles['form_overview_heading_con']}>
                <h2 className={styles['form_overview_heading']}>Form Overview</h2>
                {(formtemplateStatus === 'SUBMITTED' && privileges?.MANAGE_FORM_TEMPLATE_APPROVAL?.includes(Privileges.MODIFY)) &&
                    <div className={styles['form_overview_action_btns']}>
                        <button onClick={() => handleFormReview('Approve')} className={styles['approve_btn']}>Approve</button>
                        <button onClick={() => handleFormReview('Reject')} className={styles['reject_btn']}>Reject</button>
                    </div>}
            </div>
            {formFieldsWithSection?.map((section, index) =>
                <div key={index} className={styles['form_overview_sections']}>
                    <h1>{section?.sectionName}</h1>
                    <div className={styles['form_overview_sections_fields']}>
                        {
                            section?.formFields?.map((field, index) =>
                                (field.type !== 'checkbox' && field.type !== 'radio' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field)
                                        }
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                    <div className={styles['form_overview_sections_radio_fields']}>
                        {
                            section?.formFields?.map((field, index) =>
                                (field.type === 'radio' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field)
                                        }
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                    <div className={styles['form_overview_sections_checkbox_fields']}>

                        {
                            section?.formFields?.map((field, index) =>
                                (field.type === 'checkbox' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field)
                                        }
                                        <span style={{ height: 5 }}></span>
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>

                </div>
            )}
            {participantFeeList?.length != 0 &&
                <div className={styles['participant_fee_con']}>
                    <h1>Participant Fee</h1>
                    <div className={styles['participant_fee_list']}>
                        {
                            participantFeeList?.map((pf, index) =>
                                <ParticipantFeeCard key={index} participantFee={pf} isOverview={true} />
                            )
                        }
                    </div>
                </div>}
            {waiverList?.length != 0 &&
                <div className={styles['waiver_list']}>
                    <h1>Waiver</h1>
                    {waiverList?.map((waiver, index) =>
                        <div key={index} className={styles['waiver_card']}>
                            <h2>{waiver?.name}</h2>
                            <p>{waiver?.desc}</p>
                        </div>
                    )}
                </div>}
            {((paymentMethodDetails.online_payment.length != 0) || (paymentMethodDetails.offline_payment.length != 0)) &&
                <div className={styles['form_overview_payment_methods']}>
                    <h1>Payment Options</h1>
                    <div className={styles['form_payment_method_list']}>
                        {
                            Object.entries(paymentMethodDetails)?.map(([key, value]) =>
                                <React.Fragment key={key}>
                                    {((key === 'online_payment' && value.length != 0) || (key === 'offline_payment' && value.length != 0)) &&
                                        <div className={styles['form_payment_method_card']}>
                                            <Radio sx={radioBtnStyle}  onChange={(e) => handlePaymentMethodType(key?.replaceAll("_", " "), e.target.checked)} checked={paymentMethodType.includes(key.replaceAll("_", " "))} />
                                            <p>{key?.replaceAll("_", " ")}</p>
                                        </div>}
                                    <div className={styles['online_payment_method_list']}>
                                        {/* {value?.map((pm, index) =>
                                            <div className={styles['online_payment_method_card']}>
                                                <div key={index} className={styles['online_payment_method_card_heading']}>
                                                    <img src={getLogoByPaymentMethodName(pm?.paymentMethodName)} alt={pm?.paymentMethodName} />
                                                    <h4>{pm?.paymentMethodName?.replaceAll("_", " ")}</h4>
                                                </div>
                                                <Radio sx={radioBtnStyle} />
                                            </div>)} */}
                                        {value?.map((pm, index) =>
                                            <Accordion
                                                elevation={0}
                                                sx={{
                                                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
                                                    borderRadius: '15px',
                                                    height: 'max-content',
                                                    minHeight: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    '&.Mui-expanded': {
                                                        minHeight: 0,
                                                        margin: 0
                                                    },
                                                }}

                                            >
                                                <AccordionSummary
                                                    aria-controls="panel1-content"
                                                    id="panel1-header"

                                                >

                                                    <div key={index} className={styles['online_payment_method_card']}>
                                                        <div key={index} className={styles['online_payment_method_card_heading']}>
                                                            <img src={getLogoByPaymentMethodName(pm?.paymentMethodName?.replaceAll("_", " "))} alt="credit card" />
                                                            <h4>{pm?.paymentMethodName?.replaceAll("_", " ")}</h4>
                                                        </div>
                                                        <Radio sx={radioBtnStyle} />
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography>
                                                        {pm?.payMethodDesc}
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>)}
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default FormOverview